import React, { useState, useId } from 'react';
import PropTypes from 'prop-types';
import { LuChevronUp, LuChevronDown } from "react-icons/lu";
import "../pages/Services.scss"

const ServiceCommitment = ({ id, name, description, fullDescription, image, imageWidth, imageHeight }) => {
    const [expanded, setExpanded] = useState(false);
    const descriptionId = useId();

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <div className="card service-detail-card mb-4">
            <div className="card-body">
                <div className="row">
                    <div className="col-12 order-1 order-md-0 d-flex justify-content-start mb-2">
                        <span className="ak-blue f-25" style={{ fontWeight: 700 }}>{id}</span>
                    </div>

                    <div className="col-12 col-md-4 order-2 order-md-1 mb-3 mb-md-0">
                        <img
                            src={image}
                            width={imageWidth}
                            height={imageHeight}
                            alt=""
                            className="img-fluid rounded service-img"
                        />
                    </div>

                    <div className="col-12 col-md-8 order-3 order-md-2 text-start">
                        <h2 className="card-title ak-blue f-25 semi-bold">{name}</h2>

                        <div className="card-text-wrapper" id={descriptionId}>
                            <p className="card-text">
                                {expanded ? fullDescription : description}
                            </p>
                        </div>

                        <button onClick={handleToggle} className="ak-round-btn" style={{ minWidth: 160 }}
                                aria-expanded={expanded} aria-controls={descriptionId}>
                            {expanded ? 'Show Less' : 'Learn More'}
                            {expanded ? <LuChevronUp aria-hidden="true" /> : <LuChevronDown aria-hidden="true" />}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ServiceCommitment.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    fullDescription: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageWidth: PropTypes.number,
    imageHeight: PropTypes.number,
};

export default ServiceCommitment;
